
import easyDialog from "@/lib/easy-dialog";

const ShowDialogForSubscribe = (title: string, contentInfo: string) => {
  easyDialog.open({
    container: {
      header: title,
      content: '<span class="Font_15">' + contentInfo.replace(new RegExp('\n', 'g'), '<br/>') + '</span>',
      yesFn: () => {
        easyDialog.close();
      },
      yesText: '<span class="Font_15">OK</span>'
    },
    fixed: true,
    drag: false
  });
}

const OpenThirdPartyResubscribeForm = (url: string) => {
  easyDialog.open({
    container: {
      header: 'Resubscribe Email',
      content: '<iframe id="iframe" src="' + url + '" frameborder="0" style="width:520px; max-width:100%; height:180px;" scrolling="no" ></iframe>',
    },
    fixed: true,
    drag: false
  });
}

const ajaxprocess = (result: string, email: string) => {
  if (result === 'unsubscribed') { // 已取消订阅--弹出Resubscribe Form
    var resubscribeUrl = "/ThirdPartySubscribe/ResubscribeEmail.aspx?email=" + encodeURIComponent(email);
    OpenThirdPartyResubscribeForm(resubscribeUrl);
  }
  else if (result === 'subscribed') { // 已订阅
    ShowDialogForSubscribe("Subscribe Info", "<font size=\"4\">Looks like you are already subscribed!</font><br /><br />Please, add <span style=\"text-decoration: underline;\">info@anypromo.com</span> to your address book to ensure delivery.");
  }
  else if (result === 'ok') { // 首次订阅
    ShowDialogForSubscribe("Subscribe Info", "<font size=\"4\">Thank you for subscribing.</font><br /><br />Please, add <span style=\"text-decoration: underline;\">info@anypromo.com</span> to your address book to ensure delivery.");
  }
  else if (result === 'Please input first Name.') {
    $("#txtFname").val('');
    ShowDialogForSubscribe("Subscribe Info", result);
  }
  else if (result === 'Please input last Name.') {
    $("#txtLname").val('');
    ShowDialogForSubscribe("Subscribe Info", result);
  }
  else if (result !== undefined) {
    ShowDialogForSubscribe("Subscribe Info", result);
  }
}

export const ThirdPartySubscribeOptIn = (email: string, source: string, firstName: string, lastName: string, industry: string, industryOther: string, code?: string) => {
  code = code || '';

  const param = {
    email: email,
    source: source,
    code: code,
    firstName: firstName,
    lastName: lastName,
    industry: industry,
    industryOther: industryOther,
    UserAgent: window.navigator.userAgent
  };


  fetch("/EDM/Subscribe_Attached.aspx/SubscribeOptIn", {
    method: "POST",
    headers: {
      'content-type': "application/json; charset=utf-8",
    },
    body: JSON.stringify(param)
  }).then(res => res.json()).then((data) => {
    //成功回调函数
    window.robotVerified = function (response: any) {
      ThirdPartySubscribeOptIn(email, source, firstName, lastName, industry, industryOther, response);
    };

    if (data.d.indexOf('recaptcha') == 0) {
      var arr = data.d.split('_|_');
      $.getScript("//www.google.com/recaptcha/api.js");
      //弹出验证码提示框
      var str = '<div class="subscribe-form">\
<dl>\
    <dt>Your email: </dt>\
    <dd>'+ email + '</dd>\
</dl>\
<div class="recaptcha">\
    <div id="J-recaptcha" class="g-recaptcha" data-callback="robotVerified" data-sitekey="'+ arr[1] + '"></div>\
    <div class="error-info"></div>\
</div>\
</div>';

      easyDialog.open({
        container: {
          header: 'Confirmation',
          content: str,
          cusTextClass: ' subscribe-dialog'
        },
        fixed: true,
        drag: false
      });

    } else {
      ajaxprocess(data.d, email);
    }
  });
}